import { FC } from 'react'
import { Avatar2 } from '@components-v2/atoms/Avatar2'
import classNames from 'classnames'
import styles from './index.module.scss'

type Props = {
  src: string
  text: string
  supportingText: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

export const AvatarLabelGroup: FC<Props> = ({ src, text, supportingText, size = 'md' }) => {
  return (
    <div
      className={classNames(styles.container, {
        [styles.sm]: size === 'sm',
        [styles.md]: size === 'md',
        [styles.lg]: size === 'lg',
        [styles.xl]: size === 'xl',
      })}
    >
      <div className={styles.avatar}>
        <Avatar2 src={src} size={size} />
      </div>
      <div className={styles.content}>
        <div className={styles.text}>{text}</div>
        <div className={styles.supportingText}>{supportingText}</div>
      </div>
    </div>
  )
}
